import { Box } from "@mui/material";
import { styled } from "@mui/system";
import CurrencyConverter from "../popovers/CurrencyConverter/CurrencyConverter";
import useAuth from "../../../hooks/useAuth";
import WorkflowTaskNotifications from "../popovers/WorkflowTasks";
import { RightSideBarStyles } from "./styles";
import UserDailyOperations from "../../../pages/UserGuide/UserDailyOperations";
import { USER_TYPES } from "../../../constants/user-types";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const RightSideBarBarWrapper = styled(Box)(({ theme }) => ({
  background: "#fff",
  height: "100vh",
  paddingLeft: 5,
  paddingRight: 5,
  borderTopLeftRadius: 40,
  transition: "width 0.3s ease",
  position: "fixed",
  marginRight: "auto",
  [theme.breakpoints.down("md")]: {
    paddingLeft: 5,
    paddingRight: 5,
    width: "100%",
    borderTopLeftRadius: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: 80,
    marginTop: "auto",
    display: "flex",
    flexDirection: "row",
    zIndex: 1000,
    borderTop: "1px solid #D9D9D9",
    ".task-item": {
      height: "86px",
      ".label": {
        marginTop: "2px",
      },
    },
  },
}));

const RightSideBar = () => {
  const { user }: any = useAuth();

  const isRightUser = (requiredUsers?: string[]) => {
    if (!requiredUsers) return true;
    return requiredUsers.includes(user?.type);
  };

  const handleUserManual = () => {
    window.open(
      "https://zimba.gitbook.io/user-manual/",
      "_blank",
      "noreferrer",
    );
  };

  return (
    <>
      <Box>
        <RightSideBarBarWrapper className="task-bar">
          {!isRightUser([USER_TYPES.SYSTEM_USER]) && (
            <Box
              sx={{ ...RightSideBarStyles.taskContainer }}
              className="task-item"
            >
              <UserDailyOperations />
            </Box>
          )}

          <Box
            sx={{ ...RightSideBarStyles.taskContainer }}
            className="task-item"
          >
            <WorkflowTaskNotifications />
          </Box>

          <Box
            sx={{ ...RightSideBarStyles.taskContainer }}
            className="task-item"
          >
            <CurrencyConverter />
          </Box>

          {!isRightUser([USER_TYPES.SYSTEM_USER]) && (
            <Box
              sx={{ ...RightSideBarStyles.taskContainer }}
              className="task-item"
            >
              <Box
                sx={{
                  ...RightSideBarStyles.iconWrapper,
                  background: "#96A2C0",
                }}
                onClick={handleUserManual}
              >
                <HelpOutlineIcon />
              </Box>
              <Box sx={{ ...RightSideBarStyles.label }} className="label">
                User Manual
              </Box>
            </Box>
          )}
        </RightSideBarBarWrapper>
      </Box>
    </>
  );
};

export default RightSideBar;
